// extracted by mini-css-extract-plugin
export default {"main_header":"Header_main_header__xUxhz","header_inner":"Header_header_inner__PuKpW","brand":"Header_brand__elJ85","hamburger_menu":"Header_hamburger_menu__2dUHG"};